import React, { ReactNode } from "react";
import styles from "./Fullpage.module.scss";
import classNames from "classnames";

type Props = {
  children?: ReactNode;
  className?: string;
};
function FullpageModal(props: Props) {
  return (
    <div
      className={classNames(styles.background, props.className)}
      id="package-scroll"
    >
      {props.children}
    </div>
  );
}

export default FullpageModal;
